import BaseModel from "./base/baseModel";

export default class ProdutoAliquotaInterestadualModel extends BaseModel {
    id?: number = null;
    produtoId?: number = null;
    ufDestino: string = null;
    aliquota: number = null;
}